module.exports = __webpack_public_path__ + "static/media/home_delivery.03cf7369.jpg";